import { render, staticRenderFns } from "./RowHeader.vue?vue&type=template&id=139d5675&scoped=true&"
import script from "./RowHeader.vue?vue&type=script&lang=js&"
export * from "./RowHeader.vue?vue&type=script&lang=js&"
import style0 from "./RowHeader.vue?vue&type=style&index=0&id=139d5675&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d5675",
  null
  
)

export default component.exports